import { FC, useState } from 'react';
import { Button } from '@spotted-zebra-uk/ui-components';
import CandidateListModal from './DirectInvitationModal';

interface ICandidateListButton {
  projectId: number;
  projectSubId: string;
  stageSubId: string;
  disabledIndirectInvitationButton: boolean;
}

const CandidateListButton: FC<ICandidateListButton> = ({
  projectId,
  projectSubId,
  stageSubId,
  disabledIndirectInvitationButton,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        onClick={handleOpenModal}
        size="small"
        variant="tertiary"
        disabled={disabledIndirectInvitationButton}
      >
        Invite via email
      </Button>
      {isModalOpen ? (
        <CandidateListModal
          onClose={handleCloseModal}
          projectId={projectId}
          projectSubId={projectSubId}
          stageSubId={stageSubId}
        />
      ) : null}
    </>
  );
};

export default CandidateListButton;
